import React, { useState, useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { deflate, inflate } from "pako";
import loading_ from "../Assets2/loading.gif";
import bg1 from "../Assets2/screenshot1.png";
import bg2 from "../Assets2/screenshot2.png";
import bg3 from "../Assets2/screenshot3.png";
import bg4 from "../Assets2/screenshot4.png";
import bg5 from "../Assets2/screenshot5.png";
import bg6 from "../Assets2/screenshot6.png";
import bg7 from "../Assets2/screenshot7.png";
import bg8 from "../Assets2/screenshot8.png";
import bg9 from "../Assets2/screenshot9.png";
import bg10 from "../Assets2/screenshot10.png";
import bg11 from "../Assets2/screenshot11.png";
import bg12 from "../Assets2/screenshot12.png";
import "./CSS/Page_Mnagment.css";
import BtnCellRenderer2 from "./BtnCellRenderer2.jsx";
import { Link } from "react-router-dom";
import "./CSS/All.css";
import yuzonbir from "../Assets/a_1.png";
import yuzonikş from "../Assets/a_2.png";
import pcc from "../Assets/a_3.png";
import elec_generator from "../Assets/a_4.png";
import air_chiller_2 from "../Assets/a_5.png";
import boiler from "../Assets/a_6.png";
import chiller from "../Assets/a_7.PNG";
import chiller2 from "../Assets/a_8.jpg";
import esanjor from "../Assets/a_9.PNG";
import valve_png from "../Assets/a_10.png";
import a from "../Assets/a_11.png";
import b from "../Assets/a_12.png";
import c from "../Assets/a_13.png";
import d from "../Assets/a_14.png";
import e from "../Assets/a_15.png";
import f from "../Assets/a_16.png";
import g from "../Assets/a_17.png";
import h from "../Assets/a_18.png";
import i from "../Assets/a_19.png";
import j from "../Assets/a_20.png";
import k from "../Assets/a_21.png";
import l from "../Assets/a_22.png";
import m from "../Assets/a_23.png";
import n from "../Assets/a_24.PNG";
import b2 from "../Assets/a_25.PNG";
import c2 from "../Assets/a_26.PNG";
import d2 from "../Assets/a_27.PNG";
import e2 from "../Assets/a_28.PNG";
import water_chiller from "../Assets/a_29.png";
import analy from "../Assets/6744989.png";
import speedr from "../Assets/3563394.png";
import steam from "../Assets/1724304.png";
import sun_energy from "../Assets/4114970.png";
import redbell from "../Assets/559343.png";
import pontoon from "../Assets/1505455.png";
import carbon_foot from "../Assets/7822060.png";
import { useDispatch, useSelector } from "react-redux";
import Store from "../Store/Store";
import {
    add_page_name,
    add_pop_up_widget,
    clear_pop_up_widget,
    remove_paGE,
    remove_Widget,
    set_render_items_toolbox,
    set_temp_id,
    set_toolbox,
    set_white_space,
    set_widget_library,
} from "../Action/Action";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import GaugeChart from "react-gauge-chart";
import Draggable from "react-draggable";
import { render } from "react-dom";

import _ from 'lodash';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const availableHandles = ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'];

const LineChart = ({ data, labels, yAxisName }) => {
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: "Random Data",
                data: data,
                fill: false,
                borderColor: "rgb(75, 192, 192)",
                tension: 0.1,
            },
        ],
    };
    const options = {
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Zaman",
                },
            },
            y: {
                title: {
                    display: true,
                    text: yAxisName,
                },
            },
        },
    };

    return (
        <div>
            <Line options={options} data={chartData} />
        </div>
    );
};

const Template_Widget_Management = (props) => {

    const {
        className = 'layout',
        rowHeight = 30,
        onLayoutChange = () => { },
        cols = { lg: 120, md: 10, sm: 7, xs: 3, xxs: 2 },
    } = props;

    const [currentBreakpoint, setCurrentBreakpoint] = useState('lg');
    const [compactType, setCompactType] = useState('vertical');
    const [resizeHandles, setResizeHandles] = useState(['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne']);
    const [mounted, setMounted] = useState(false);
    const [layouts, setLayouts] = useState({ lg: [], md: [], sm: [], xs: [], xxs: [] });


    useEffect(() => {
        const componentDidMount = async () => {
            try {
                const req__ = await fetch(
                    "https://app-rmmsapi.azurewebsites.net/api/pages/GetWidgetsList",
                    {
                        headers: {
                            Accept: "applicaiton/json",
                            "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                            companyId: String(props.com_id),
                        }),
                    }
                );

                const response__ = await req__.json();
                console.warn(response__);

                if (req__.status === 200) {
                    Store.dispatch(set_widget_library(response__));
                }
            } catch (err) {
                console.warn(err);
            }
        }
        componentDidMount();
    }, [])


    const [tag_values, Set_tag_values] = useState([]);
    const history = useHistory();

    const [min, SetMin] = useState(0);
    const [max, SetMax] = useState(0);
    const [page_id, Set_page_id] = useState("");

    const [pop_up_widget, Set_pop_up_widget] = useState([]);

    const [temp_id, Set_temp_id] = useState("")

    //yetkilendirme
    const [page_management_silme, Set_page_management_silme] = useState(false);
    const [page_management_yazma, Set_page_management_yazma] = useState(false);


    useEffect(() => {
        console.log(
            props.yetkilendirme_state[props.auth_reducer],
            props.auth_reducer
        );

        props.users_list.forEach(x => {

            if (x.userId === props.auth_reducer && x.yetkilendirme) {
                console.log(x);
                let yetki_parse = JSON.parse(x.yetkilendirme)
                let com_id = props.temp_com_id || 2;
                Object.entries(yetki_parse[com_id]).forEach(s => {
                    if (s[0] === "Template_Management") {
                        if (s[1].S === "t") {
                            Set_page_management_silme(true);
                        } else {
                            Set_page_management_silme(false);
                        }

                        if (s[1].Y === "t") {
                            Set_page_management_yazma(true);
                        } else {
                            Set_page_management_yazma(false);
                        }


                    }
                })
            }
        })


        console.log(props.auth_reducer);
    }, [props.auth_reducer, props.tag_ids]);



    const OnChangeMin = (e) => {
        SetMin(e.target.value);
    };

    const OnChangeMax = (e) => {
        SetMax(e.target.value);
    };
    const [deneme1, Set_deneme1] = useState(0)



    const [inputValue3, setInputValue3] = useState("");
    const [selectedOption3, setSelectedOption3] = useState("Select");
    const [isActive3, setIsActive3] = useState(false);
    const [inputValue1, setInputValue1] = useState("");
    const [selectedOption1, setSelectedOption1] = useState("Select");
    const [isActive1, setIsActive1] = useState(false);
    const [inputValue2, setInputValue2] = useState("");
    const [selectedOption2, setSelectedOption2] = useState("Select");
    const [isActive2, setIsActive2] = useState(false);
    const [inputValue4, setInputValue4] = useState("");
    const [selectedOption4, setSelectedOption4] = useState("Select");
    const [isActive4, setIsActive4] = useState(false);

    const handleDropdownClick3 = () => {
        setIsActive3(!isActive3);
    };

    const handleDropdownBlur3 = () => {
        setIsActive3(false);
    };
    const handleOptionClick3 = (optionValue) => {
        setSelectedOption3(optionValue);
        setInputValue3(optionValue);
    };

    const handleDropdownClick1 = () => {
        setIsActive1(!isActive1);
    };

    const decompressData = (compressedData) => {
        try {
            const decompressed = inflate(compressedData, { to: "string" });
            console.log(decompressed);
            return decompressed;
        } catch (error) {
            console.error("Decompression error:", error);
        }
    };

    const compressData = (data) => {
        try {
            const compressed = deflate(data, { to: "string" });
            console.log(compressed);
            decompressData(compressed);
            return compressed;
        } catch (error) {
            console.error("Compression error:", error);
        }
    };

    const handleDropdownBlur1 = () => {
        setIsActive1(false);
    };
    const handleOptionClick1 = (optionValue) => {
        setSelectedOption1(optionValue);
        setInputValue1(optionValue);
    };
    const handleDropdownClick4 = () => {
        setIsActive4(!isActive4);
    };

    const handleDropdownBlur4 = () => {
        setIsActive4(false);
    };
    const handleOptionClick4 = (optionValue) => {
        setSelectedOption4(optionValue);
        setInputValue4(optionValue);
    };
    const handleDropdownClick2 = () => {
        setIsActive2(!isActive2);
    };

    const handleDropdownBlur2 = () => {
        setIsActive2(false);
    };
    const handleOptionClick2 = (optionValue) => {
        setSelectedOption2(optionValue);
        setInputValue2(optionValue);
    };
    const [data, setData] = useState([]);

    const exampleData = [
        { x: 1, y: 10 },
        { x: 2, y: 20 },
        { x: 3, y: 15 },
        // Add more data points as needed
    ];

    const [selected_html_tag, Set_selected_html_tag] = useState(null);

    const [selected_tags, Set_selected_tags] = useState([]);

    const [items3_3, Set_items3_3] = useState([]);

    const [ls_items, Set_ls_items] = useState([]);

    useEffect(() => {
        console.log(selected_html_tag);
    }, [selected_html_tag]);

    useEffect(() => {
        const componentDidMount = async () => {
            let items = localStorage.getItem("items");
            let json_items = JSON.parse(items);
            if (json_items) {
                Set_ls_items(json_items);
            }
            if (props._tag_ids && props._tag_ids.length > 0) {
                try {
                    const request = await fetch(
                        "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                        {
                            headers: {
                                "Content-Type": "application/json",
                                accept: "application/json",
                            },
                            method: "POST",
                            body: JSON.stringify(props._tag_ids),
                        }
                    );
                    const response = await request.json();

                    Set_tag_values(response);
                } catch (err) {
                    console.log(err);
                }
            }
        };
        componentDidMount();
    }, [props._tag_ids]);

    useEffect(() => { console.log(currentBreakpoint); }, [currentBreakpoint])


    // react-grid-layout-functions

    const onBreakpointChange = (breakpoint) => {
        console.log(breakpoint);
        setCurrentBreakpoint(breakpoint);
    };

    const onCompactTypeChange = () => {
        setCompactType((oldCompactType) =>
            oldCompactType === 'horizontal'
                ? 'vertical'
                : oldCompactType === 'vertical'
                    ? null
                    : 'horizontal'
        );
    };

    const onResizeTypeChange = () => {
        setResizeHandles((currentHandles) =>
            currentHandles === availableHandles ? ["se"] : availableHandles
        );

    };

    useEffect(() => {
        console.log(layouts);
    }, [layouts])





    const onDragStop = (elemParams, first, last) => {
        setLayouts(prevLayouts => {
            const updatedLayouts = { ...prevLayouts };
            updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layoutItem => {
                if (String(layoutItem.id) === last.i) {
                    return { ...layoutItem, x: last.x, y: last.y };
                }
                return layoutItem;
            });
            return updatedLayouts;
        });
    };

    const onResize = (elemParams, first, last) => {
        setLayouts(prevLayouts => {
            const updatedLayouts = { ...prevLayouts };
            updatedLayouts[currentBreakpoint] = updatedLayouts[currentBreakpoint].map(layoutItem => {
                if (layoutItem.id === last.i) {
                    return { ...layoutItem, w: last.w, h: last.h };
                }
                return layoutItem;
            });
            return updatedLayouts;
        });
    };

    const [text_state, SetText_State] = useState(0);
    const [tag_text, Settag_text] = useState(0);
    const [button_state, Setbutton_state] = useState(0);
    const [resim_state, Setresim_state] = useState(0);

    const cardBodyRef = useRef(null);

    const [render_items, Setrender_items] = useState([]);

    const [items3, Set_items3] = useState(props.toolbox);
    useEffect(() => {
        Set_items3(props.toolbox);
    }, [props.toolbox]);

    let tags_ = [];

    const [tags, SetTags] = useState([]);

    const chartData = {
        labels: data.map((point) => point.x),
        datasets: [
            {
                label: "Trend Data",
                data: data.map((point) => point.y),
                fill: false,
                borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                title: {
                    display: true,
                    text: "X-axis Label", // Replace with your X-axis label
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Y-axis Label", // Replace with your Y-axis label
                },
            },
        },
    };



    const [selectedImage, setSelectedImage] = useState([]);
    const [selectedImagebg, setSelectedImagebg] = useState([]);

    let led = false;


    const [loading, SetLoading] = useState(true);
    const [bg, SetBG] = useState([]);
    const [main_title, Set_Main_title] = useState("");
    const [main_title2, Set_Main_title2] = useState("");

    const [items, SetItems] = useState([]);

    const proxyUrl = "https://cors-anywhere.herokuapp.com/";

    const [image, setImage] = useState([]);
    const [widget, setWidget] = useState([]);
    const [text, SetText] = useState("");


    const [popup_state, Set_popup_state] = useState({})

    let link_widget = [];
    let gaugeWidget = [];
    let names_widget = [];
    let names_widget2 = [];
    let trends_widget = [];

    function encodeBase64FromArray(array) {
        let binary = "";
        for (let i = 0; i < array.length; i++) {
            binary += String.fromCharCode(array[i]);
        }
        return btoa(binary);
    }

    const [gaugeValueMax, SetgaugevalueMax] = useState(null);
    const [gaugeValue, Setgaugevalue] = useState(null); // A value between 0 and 1

    const gaugeConfig = {
        // Configuration options (optional)
        // For example: arcWidth: 0.1, arcPadding: 0.02, etc.
    };

    const onChangeGaugeMax = (e) => {
        SetgaugevalueMax(Number(e.target.value));
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = async (event) => {
            let long_string = event.target.result;

            setSelectedImage([
                ...selectedImage,
                {
                    src: long_string,
                    w: 280,
                    h: 320,
                    id: 110 - selectedImage.length,
                    x: Math.floor(Math.random() * 200),
                    y: Math.floor(Math.random() * 200),
                },
            ]);
        };

        reader.readAsDataURL(file);
    };

    const handleImageUploadbg = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = async (event) => {
            let long_string = event.target.result;

            setSelectedImagebg([
                {
                    src: long_string,
                    id: 112 - selectedImage.length,
                },
            ]);
        };

        reader.readAsDataURL(file);
    };

    const OnFormSubmit = async (e) => {
        e.preventDefault();

        console.log(items3, "aaaaawwww");


        try {
            if (text === "") {
                alert("Lütfen sayfa ismi giriniz!");
            } else if (text === "Main Page") {
                alert("Bu sayfa adını giremezsiniz!")
            }
            else {
                control = true;
                SetLoading(true);
                await Store.dispatch(add_page_name(text));
                e.target.parentElement.firstElementChild.value = "";
                let images_ = [];
                let widgets_ = [];
                let background_ = [];
                let white_spaces = [];

                let new_array = items3;

                new_array.forEach((item) => {
                    console.log(item);
                    if (item.type === "image") {
                        var x = Math.floor(Math.random() * 420);
                        var y = Math.floor(Math.random() * 420);

                        images_.push({
                            id: item.id,
                            x: x,
                            y: y,
                            w: 200,
                            h: 220,
                            src: item.elementDetails.src,
                        });
                        console.log(images_[images_.length - 1]);
                    } else if (item.type === "bg") {
                        background_.push({ id: item.id, src: item.elementDetails.src });
                    } else if (item.type === "text") {
                        widgets_.push({
                            title_widget: item.elementDetails.text,
                            type: "text",
                            id: item.id,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "title") {
                        widgets_.push({
                            title_widget: item.elementDetails.text,
                            type: "title",
                            id: item.id,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "gauge") {
                        widgets_.push({
                            id: item.id,
                            type: "gauge",
                            tagId: item.elementDetails.tagId,
                            tagName: item.elementDetails.tagName,
                            max_value: item.elementDetails.max_value,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "trend") {
                        console.log(item);

                        widgets_.push({
                            id: item.id,
                            type: "trend",
                            tagId: item.elementDetails.tagId,
                            tagName: item.elementDetails.tagName,
                            axis_name: item.elementDetails.axis_name,
                            x: item.x,
                            y: item.y,
                        });
                    } else if (item.type === "label") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "label",
                            main_title: item.main_title,
                            tagId: item.tagId,
                            text: item.text,
                            led: item.led,
                            max: item.max,
                            min: item.min,
                        });
                    } else if (item.type === "select") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "select",
                            tagId: item.elementDetails.id,
                            tagName: item.elementDetails.text,
                        });
                    } else if (item.type === "button") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "button",
                            page_name: item.elementDetails.text,
                        });
                    } else if (item.type === "white_space") {
                        console.log(item);
                        white_spaces.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "white_spaces",
                            elementDetails: item.elementDetails,
                        });
                    } else if (item.type === "text_box") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "text_box",
                            elementDetails: { text: item.text },
                        });
                    }
                    else if (item.type === "tag") {
                        widgets_.push({
                            id: item.id,
                            x: item.x,
                            y: item.y,
                            type: "tag",
                            elementDetails: { text: item.elementDetails.text, tagId: item.elementDetails.tagId },
                        });
                    } else if (item.type === "pop_up_widget") {
                        pop_up_widget.forEach(item_ => {
                            if (item_.id === item.id) {
                                widgets_.push({
                                    id: item.id,
                                    x: item.x,
                                    y: item.y,
                                    type: "pop_up_widget",
                                    elementDetails: { text: item.elementDetails.text, tagId: item.elementDetails.tagId, pop_up: item_ },
                                })
                            }
                        })

                    }
                });

                let x = 0;
                let new_white_spaces = [];
                const uniqueById = white_spaces.reduce((unique, item) => {
                    if (!unique.some((obj) => obj.id === item.id)) {
                        unique.push(item);
                    }
                    return unique;
                }, []);

                console.log(uniqueById);

                const uniqueById_widget = widgets_.reduce((unique, item) => {
                    if (!unique.some((obj) => obj.id === item.id)) {
                        unique.push(item);
                    }
                    return unique;
                }, []);

                let set_sql_items = {
                    Pages: [
                        {
                            text: text,
                            images: images_,
                            widgets: uniqueById_widget,
                            white_spaces: uniqueById,
                            bgs: background_,
                        },
                    ],
                };
                console.log(set_sql_items);
                console.log(JSON.stringify(set_sql_items));
                try {
                    const req_ = await fetch(
                        `httpS://rmmsapi.azurewebsites.net/api/pages/AddPage`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                accept: "application/json",
                            },
                            body: JSON.stringify({
                                PageId: 0,
                                userId: props.auth_reducer,
                                companyId: props.company_id,
                                pageName: text,
                                details: JSON.stringify(set_sql_items),
                            }), // Convert the body object to a JSON string
                        }
                    );
                    const response = await req_.json();
                } catch (err) {
                    console.log(err, "aüaüaüaüaüaüüaaü");
                }
                // add_pages_names(text)
            }
        } catch (err) {
            console.log(err);
        } finally {
            Store.dispatch(set_render_items_toolbox([]));
            Store.dispatch(set_white_space([]));
            Store.dispatch(set_toolbox([]));
            window.location.reload();
        }
    };

    // const add_pages_names = (text_) => {
    //     console.log(text);
    //     databasefirebase.ref(`${props.auth_reducer}/Pages_Names`).push(text_)

    // }

    const input_text = (e) => {
        e.preventDefault();

        let text_ = e.target.value;
        if (text_.includes("_")) {
            alert("Page name cannot include special characters!");
            text_ = text_.replaceAll("_", " ");
        } else if (text_.includes("/")) {
            alert("Page name cannot include special characters!");
            text_ = text_.replaceAll("/", "");
        } else {
            SetText(text_);
        }
    };

    var control = loading;

    const [pages, SetPages] = useState(props.widgets_library);

    useEffect(() => {

        if (props.widgets_library.length > 0) {
            SetPages(props.widgets_library);
            var list__ = props.widgets_library;

            setTimeout(() => {
                SetLoading(false);
                control = false;

                SetItems(list__);
            }, 1200);

            setData(exampleData);
        } else {
            setTimeout(() => {
                SetLoading(false);
                control = false;
            }, 600);
        }
    }, [props.widgets_library]);

    useEffect(() => {
        if (!control) {
            console.log(control);
        }
    }, [control]);

    const delete_page = async (e) => {
        e.preventDefault();

        control = true;


        var selected_id =
            e.target.parentElement.parentElement.id;
        console.log(selected_id);
        //widgets and images db

        // just pages name db

        var confirm = window.confirm(
            "Bu widget'ı silmek istediğinizden emin misiniz?"
        );

        var newlist = []; //for widgets and images
        var newList2 = []; // for pages names

        if (confirm) {
            SetLoading(true);
            if (props.widgets_library) {
                props.widgets_library.forEach(async (item) => {

                    if (String(item.widgetId) === selected_id) {
                        await Store.dispatch(remove_Widget(item.widgetId))
                        try {
                            const req_ = await fetch(
                                `https://app-rmmsapi.azurewebsites.net/api/pages/DeleteWidget`,
                                {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        accept: "application/json",
                                    },
                                    body: JSON.stringify({
                                        widgetId: item.widgetId,
                                    }), // Convert the body object to a JSON string
                                }
                            );
                            const response = await req_.json();
                            console.log(response);
                        } catch (err) {
                            console.log(err);
                        } finally {
                        }
                    }
                });
            }

            e.target.parentElement.parentElement.parentElement.style.display = "none";

        } else {
            return 0
        }
    };

    const images_click = (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }
        const images = document.querySelector(".all_hidden_images");
        images.classList.toggle("all_hidden_images_active");
        if (
            document
                .querySelector(".add_widget_part")
                .classList.contains("add_widget_part_active")
        ) {
            document
                .querySelector(".add_widget_part")
                .classList.remove("add_widget_part_active");
        } else if (
            document
                .querySelector("#sxxch-bg-31")
                .classList.contains("all_hidden_backgrounds_active")
        ) {
            document
                .querySelector("#sxxch-bg-31")
                .classList.remove("all_hidden_backgrounds_active");
        }
    };
    useEffect(() => {
        console.log(items3, "iterms3");
    }, [items3]);
    const widgets_click = (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        section.classList.toggle("section_dark");
        const widgets = document.querySelector(".select_widget_type");
        widgets.classList.toggle("select_widget_type_active");
        widgets.style.display = "grid";
        widgets.style.opacity = "1";
        if (
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.contains("all_hidden_images_active")
        ) {
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.remove("all_hidden_images_active");
        } else if (
            document
                .querySelector("#sxxch-bg-31")
                .classList.contains("all_hidden_backgrounds_active")
        ) {
            document
                .querySelector("#sxxch-bg-31")
                .classList.remove("all_hidden_backgrounds_active");
        }
    };

    const default_widget_click = (e) => {
        const widgets_defult = document.querySelector(".add_widget_part");
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";

        widgets_defult.classList.toggle("add_widget_part_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };
    const background_click = (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }
        const bgs = document.querySelector(".all_hidden_backgrounds");
        bgs.classList.toggle("all_hidden_backgrounds_active");
        if (
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.contains("all_hidden_images_active")
        ) {
            document
                .querySelector("#sxxc-45-ghutr")
                .classList.remove("all_hidden_images_active");
        } else if (
            document
                .querySelector(".add_widget_part")
                .classList.contains("add_widget_part_active")
        ) {
            document
                .querySelector(".add_widget_part")
                .classList.remove("add_widget_part_active");
        }
    };

    useEffect(() => {
        Setrender_items(props.render_items_length);
    }, []);

    useEffect(() => {
        console.log(render_items);
    }, [render_items]);

    const [labels_ww, Set_labels_ww] = useState(0);

    function add_widget_plus(e) {
        let title =
            e.target.parentElement.firstElementChild.nextElementSibling
                .nextElementSibling.firstElementChild.value;
        let value_ = document.querySelector("#default_widget_value_id");
        let main_title_ = main_title;
        var newdata = items3;
        Set_labels_ww(labels_ww + 1);

        let min_ = document.querySelector("#min_default").value;
        let max_ = document.querySelector("#max_default").value;
        let alarm_ = document.querySelector("#alarm_default").value;

        console.log(min_, max_);

        if (title !== "" && value_ !== "") {
            newdata.push({
                id: labels_ww + render_items.length,
                x: Math.floor(Math.random() * 100),
                y: Math.floor(Math.random() * 300),
                type: "label",
                min: Number(min_),
                max: Number(max_),
                alarm: Number(alarm_),
                text: title,
                tagId: value_.options[value_.selectedIndex].value,
                led: `${led}`,
                main_title: main_title_ !== "" ? main_title_ : "",
            });
            console.log(newdata);
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
            led = false;
        }
        console.log(newdata);
        Set_items3(newdata);
        Set_Main_title("");
        title = "";
    }
    function add_widget_plus2(e) {
        if (selectedOption1 !== "Select") {
            let title = selectedOption1;
            let value_ = document.querySelector("#select_value_id_1");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
        if (selectedOption2 !== "Select") {
            let title = selectedOption2;
            let value_ = document.querySelector("#select_value_id_2");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
        if (selectedOption3 !== "Select") {
            let title = selectedOption3;
            let value_ = document.querySelector("#select_value_id_3");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
        if (selectedOption4 !== "Select") {
            let title = selectedOption4;
            let value_ = document.querySelector("#select_value_id_4");
            names_widget2.push({
                title_widget: title,
                tagId: value_.options[value_.selectedIndex].value,
            });
            SetTags((prevArray) => [
                ...prevArray,
                { tagId: value_.options[value_.selectedIndex].value },
            ]);
            tags_.push(value_.options[value_.selectedIndex].value);
        }
    }
    function close_widget_add(e) {
        e.preventDefault();
        document.querySelectorAll("#k-w-t").forEach((i) => {
            i.style.opacity = "0";
        });
        const widgets = document.querySelector(".add_widget_part");
        widgets.classList.toggle("add_widget_part_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }

    const bg_add = async (e) => {
        e.preventDefault();
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }

        const selected_bg =
            e.target.parentElement.id || e.target.parentElement.parentElement.id;
        await SetBG([...bg, { id: selected_bg }]);
    };

    const widget_add = async (e) => {
        e.preventDefault();
        console.log(e.target.parentElement);

        var x = Math.floor(Math.random() * 420);
        var y = Math.floor(Math.random() * 420);

        if (e.target.parentElement.classList.contains("default_widget")) {
            setWidget([
                ...widget,
                {
                    names_widget: names_widget,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    main_title: main_title,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            Set_Main_title("");
            names_widget = [];
            document.querySelectorAll("#gdu-3").forEach((i) => {
                i.value = "";
            });
            tags_ = [];
        } else if (
            e.target.parentElement.classList.contains("input_select_widget")
        ) {
            setWidget([
                ...widget,
                {
                    names_widget2: names_widget2,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    main_title: main_title2,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            Set_Main_title2("");
            names_widget2 = [];

            tags_ = [];
        } else if (e.target.parentElement.classList.contains("link_widget")) {
            console.log(link_widget, "1111");
            setWidget([
                ...widget,
                {
                    links_widget: link_widget,
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            link_widget = [];
        } else if (e.target.parentElement.classList.contains("gauge_widget")) {
            setWidget([
                ...widget,
                {
                    gauges_widget: gaugeWidget,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            document.querySelectorAll("#cm0-x7y").forEach((i) => {
                i.value = "";
            });
            tags_ = [];
        } else if (e.target.parentElement.classList.contains("trend_widget")) {
            setWidget([
                ...widget,
                {
                    trends_widget: trends_widget,
                    tagId: tags_[0],
                    x: x,
                    y: y,
                    id: widget.length + 41,
                    fontSize: 14.56,
                    fontFamily: "Arial, sans-serif",
                },
            ]);
            tags_ = [];
        }

        console.log(widget);
    };

    const image_add = async (e) => {
        e.preventDefault();

        var x = Math.floor(Math.random() * 420);
        var y = Math.floor(Math.random() * 420);

        const selected_image = e.target.parentElement.id;
        await setImage([
            ...image,
            { id: selected_image, x: x, y: y, w: 285, h: 320 },
        ]);
    };

    const add_main_title = (e) => {
        Set_Main_title(e.target.value);
    };
    const add_main_title2 = (e) => {
        Set_Main_title2(e.target.value);
    };

    const edit_btn_func = (e, text) => {

        function normalizeURLPath(path) {
            const turkishMap = {
                'İ': 'I', 'ı': 'i', 'Ş': 'S', 'ş': 's',
                'Ğ': 'G', 'ğ': 'g', 'Ü': 'U', 'ü': 'u',
                'Ö': 'O', 'ö': 'o', 'Ç': 'C', 'ç': 'c'
            };

            return path.split('').map(char => turkishMap[char] || char).join('');
        }

        text = normalizeURLPath(text);


        text = text.replaceAll(" ", "_");
        history.push(`/template_management/${text}/edit`);
    };

    useEffect(() => {


    }, [props.white_space_3])
    const open_popup = (e) => {
        if (props.profile.company === "") {
            document
                .querySelector(".alert_profile_null")
                .classList.toggle("alert_profile_null_ACTIVE");
            setTimeout(() => {
                document
                    .querySelector(".alert_profile_null")
                    .classList.toggle("alert_profile_null_ACTIVE");
            }, 4000);
        } else {
            const section_all = document.querySelector("section.all_page_management");
            section_all.classList.toggle("section_all_active");
            document.querySelector(".redirect_to_dashboard-btn").style.opacity = "0";
        }
    };
    function close_widget_add2(e) {
        e.preventDefault();
        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        let section = document.querySelector("section.all_page_management");
        if (section.classList.contains("section_dark")) {
            section.classList.remove("section_dark");
        }
        const widgets = document.querySelector(".select_widget_type");
        widgets.classList.toggle("select_widget_type_active");
    }
    function close_widget_add3(e) {
        e.preventDefault();
        Set_btn_widget_control("");

        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        const widgets = document.querySelector(".link_widget");
        widgets.classList.toggle("link_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    const open_vrf_set_detail = () => {

        const widgets = document.querySelector(".button2_select_widget");
        widgets.classList.toggle("button2_select_widget_active");
    }
    function close_widget_add5(e, index) {
        e.preventDefault();

        document.querySelector(`#k-w-t-${index}`).style.opacity = 0;
        document.querySelector(`#k-w-t-${index}`).style.zIndex = "-100000000000";

        const widgets = document.querySelector(".trend_widget_toolbox");
        widgets.classList.toggle("trend_widget_toolbox_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add6(e) {
        e.preventDefault();
        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        const widgets = document.querySelector(".input_select_widget");
        widgets.classList.toggle("input_select_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add7(e) {
        e.preventDefault();
        let all_k_w_t_length = document.querySelectorAll(".gauge_widget_toolbox");
        for (let i = 0; i < all_k_w_t_length.length; i++) {
            document.querySelector(`#k-w-t-${i}`).style.opacity = 0;
            document.querySelector(`#k-w-t-${i}`).style.zIndex = "-100000000000";
        }
        const widgets = document.querySelector(".manueL-widget");
        widgets.classList.toggle("manuel_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add4(e) {
        e.preventDefault();
        const widgets = document.querySelector(".gauge_widget");
        widgets.style.opacity = 0;
        widgets.style.zIndex = "-100000000000";

        widgets.classList.toggle("gauge_widget_active");
        const widgets2 = document.querySelector(".select_widget_type");
        widgets2.style.opacity = "1";
    }
    function close_widget_add4_4(e, index) {
        e.preventDefault();

        console.log(document.querySelector(`#k-w-t-${index}`));
        document.querySelector(`#k-w-t-${index}`).style.opacity = 0;
        document.querySelector(`#k-w-t-${index}`).style.zIndex = "-100000000000";

        const widgets = document.querySelector(".gauge_widget_toolbox");
        widgets.classList.toggle("gauge_widget_toolbox_active");
    }
    const open_link_widget = () => {
        const widgets_defult = document.querySelector(".link_widget");
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";

        widgets_defult.classList.toggle("link_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };
    const open_select_widget = () => {
        const widgets_defult = document.querySelector(".input_select_widget");
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";

        widgets_defult.classList.toggle("input_select_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };
    const open_gauge_widget = () => {
        const widgets_defult = document.querySelector(".gauge_widget");
        console.log(widgets_defult);
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";
        widgets_defult.classList.toggle("gauge_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };

    const open_trend_widget = () => {
        const widgets_defult = document.querySelector(".trend_widget");
        console.log(widgets_defult);
        widgets_defult.style.opacity = "1";
        widgets_defult.style.zIndex = "100000000";
        widgets_defult.classList.toggle("trend_widget_active");
        const widgets = document.querySelector(".select_widget_type");
        widgets.style.opacity = "0";
    };

    const open_label_widget = () => {
        let popup = document.querySelector(
            ".add_widget_part.create_a_widget.default_widget"
        );
        popup.classList.toggle("add_widget_part_active");
        popup.style.opacity = "1";
        popup.style.zIndex = "100000000";
    };

    const [btn_widget_control, Set_btn_widget_control] = useState("");

    const handleDragStop = (e, data) => {
        let newdata = items3;
        console.log(data);
        newdata.forEach((item) => {
            if (String(item.id) === data.node.id) {
                var a = document.querySelectorAll(".react-draggable");
                console.log(item);
                item.x = data.x;
                item.y = data.y;
            }
        });
        console.log(newdata);
        Set_items3(newdata);
    };

    const save_function = async () => {
        var newdata = items3_3;
        newdata.push({
            items: items3,
            id: Math.floor(items3.length / 2) + widget.length + 41,
            x: Math.floor(Math.random() * 200),
            y: Math.floor(Math.random() * 200),
        });
        Set_items3_3(newdata);

        const section_all2 = document.querySelector("section.toolbox_section");
        section_all2.classList.toggle("toolbox_section_active");
        document.querySelector(".redirect_to_dashboard-btn").style.opacity = "0";
        document.querySelector(".notifications-kapsiyici").style.display = "none";
    };

    const open_toolbox = () => {
        const section_all2 = document.querySelector("section.toolbox_section");
        section_all2.classList.toggle("toolbox_section_active");
        document.querySelector(".redirect_to_dashboard-btn").style.opacity = "0";
        document.querySelector(".notifications-kapsiyici").style.display = "none";
    };

    const close_toolbox = () => {
        const section_all = document.querySelector("section.all_page_management");
        section_all.classList.toggle("section_all_active");
        const section_all2 = document.querySelector("section.toolbox_section");
        section_all2.classList.toggle("toolbox_section_active");
        document.querySelector(".redirect_to_dashboard-btn").style.opacity = "1";
        document.querySelector(".notifications-kapsiyici").style.display = "flex";
        document.querySelector(".notifications-kapsiyici").style.justifyContent =
            "center";
    };

    const closetoolbox2 = (e) => {

        var classlist = document.querySelector(".close_toolbox_i").classList
        if (classlist.contains("active")) {
            document.querySelector(".close_toolbox_i").classList.remove("active");
            document.querySelector(".close_toolbox_i").classList.add("nonactive");
            document.querySelector(".close_toolbox_i").parentElement.classList.remove("active");
            document.querySelector(".close_toolbox_i").parentElement.classList.add("nonactive");
            document.querySelector("#toolparts_id").style.height = "0px"
            document.querySelector("#toolparts_id").style.opacity = "0"
            Set_info_close_toolbox(false)



        } else if (classlist.contains("nonactive")) {
            document.querySelector(".close_toolbox_i").classList.add("active");
            document.querySelector(".close_toolbox_i").classList.remove("nonactive");
            document.querySelector(".close_toolbox_i").parentElement.classList.add("active");
            document.querySelector(".close_toolbox_i").parentElement.classList.remove("nonactive");
            document.querySelector("#toolparts_id").style.height = "50px"
            document.querySelector("#toolparts_id").style.opacity = "1"
            Set_info_close_toolbox(true)


        }
    }

    const getGaugeColor = (percent) => {
        if (percent >= 0.7) {
            return "#00FF00"; // Green color for values >= 70%
        } else if (percent >= 0.3) {
            return "#FFFF00"; // Yellow color for values >= 30%
        } else {
            return "#FF0000"; // Red color for values < 30%
        }
    };

    useEffect(() => {
        console.log(items3);
    }, [items3]);

    const delete_item_from_items3 = (e) => {
        let arr = items3.filter((i) => {
            return String(i.id) !== e.target.parentElement.id;
        });

        let arr2 = render_items;
        arr2.pop()
        Setrender_items(arr2)

        Set_items3(arr);
    }
    const get_tag_value_btn = async (id_) => {
        var data = [{

            tagId: id_
        }]

        var obj = {
            "tagValue": "",
            "tagName": "",
            "Type": "",
            "Data_Type": "",
            "Major_address": "",
            "Minor_address": "",
            "tagId": "",
            "DB_Number": ""
        }

        try {
            const req_ = await fetch(
                `https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        accept: "application/json",
                    },

                    body: JSON.stringify(data), // Convert the body object to a JSON string
                }
            );
            const response = await req_.json();
            if (response.length > 0) {
                obj.tagValue = response[0].tagValue
            }

            const req_2 = await fetch(
                `https://app-rmmsapi.azurewebsites.net/api/tags/GetTagList`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        accept: "application/json",
                    },

                    body: JSON.stringify({
                        "companyId": 1
                    }), // Convert the body object to a JSON string
                }
            );
            const response2 = await req_2.json();
            if (response2.length > 0) {
                for (let i = 0; i < response2.length; i++) {
                    if (String(response2[i].tagId) === String(id_)) {
                        obj.DB_Number = response2[i].tagDbNumber;
                        obj.Type = response2[i].tagType;
                        obj.Data_Type = response2[i].tagDataType;
                        obj.tagName = response2[i].tagName;
                        obj.Major_address = response2[i].tagAddress;
                        obj.Minor_address = response2[i].tagAddressDetail;
                        obj.tagId = response2[i].tagId;

                    }
                }
            }

            Set_popup_state(obj)
            console.log(obj);
        } catch (error) {
            console.log(error);
        }

    }

    const open_vrf_pop_up = () => {
        document.querySelector(".vrf_detail_popup").classList.toggle("vrf_detail_popup_active")
    }

    const close_vrf_pop_up = () => {
        document.querySelector(".vrf_detail_popup").classList.toggle("vrf_detail_popup_active")
        Set_popup_state({})
    }

    const [pop_up_id, Set_pop_up_id] = useState(0)
    const [info_close_toolbox, Set_info_close_toolbox] = useState(true)

    return (
        <>
            <div className="alert_profile_null">
                You need to specify the company you work for in profile page !
            </div>
            <div className="select_widget_type">
                <i onClick={close_widget_add2} id="qwesa" className="fa fa-times"></i>
                <div onClick={default_widget_click} className="s-w-t">
                    <h3>Standart Widget</h3>
                    <p>Standart labels and texts for simple widgets</p>
                </div>
                <div onClick={open_toolbox} className="s-w-t">
                    <h3>ToolBox</h3>
                    <p>Create a new widget as you wish with a toolbox.</p>
                </div>
                <div onClick={open_gauge_widget} className="s-w-t">
                    <h3>Gauge</h3>
                    <p>Create a new gauge widget to domcdcdk.</p>
                </div>
                <div onClick={open_trend_widget} className="s-w-t">
                    <h3>Trend</h3>
                    <p>Create a trend widget to compare tag data with time.</p>
                </div>
            </div>
            {control === true ? (
                <div
                    style={{
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    className="loading"
                >
                    <img style={{ width: "15%" }} src={loading_} alt="" />
                </div>
            ) : (
                <main className="page_management_main">

                    <div
                        id="k-w-t"
                        className="add_widget_part create_a_widget default_widget"
                    >
                        <i onClick={close_widget_add} className="fa fa-times"></i>
                        <input
                            style={{ color: "rgb(34,34,34)", fontSize: "21px" }}
                            type="text"
                            value={main_title}
                            onChange={add_main_title}
                            placeholder="Main Title (optional)"
                        />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <input
                                id="gdu-3"
                                placeholder="Label"
                                className="top_add_widget add_title"
                            />
                            <select
                                style={{ maxWidth: "180px" }}
                                name="default_widget_value"
                                id="default_widget_value_id"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{ width: "80%", fontWeight: "600", fontSize: "18px" }}
                            className="input-group"
                        >
                            Min Value:{" "}
                            <input
                                style={{ fontWeight: "600", fontSize: "16px" }}
                                value={min}
                                onChange={OnChangeMin}
                                type="number"
                                placeholder="min"
                                name=""
                                id="min_default"
                            />
                        </div>
                        <div
                            style={{ width: "80%", fontWeight: "600", fontSize: "18px" }}
                            className="input-group"
                        >
                            Max Value:{" "}
                            <input
                                style={{ fontWeight: "600", fontSize: "18px" }}
                                value={max}
                                onChange={OnChangeMax}
                                type="number"
                                placeholder="max"
                                name=""
                                id="max_default"
                            />
                        </div>
                        <div
                            style={{ width: "80%", fontWeight: "600", fontSize: "18px" }}
                            className="input-group"
                        >
                            Alarm Value
                            <input
                                style={{ fontWeight: "600", fontSize: "18px" }}
                                type="number"
                                placeholder="alarm"
                                name=""
                                id="alarm_default"
                            />
                        </div>
                        <div className="add_ledPart">
                            <button
                                onClick={() => {
                                    led = true;
                                }}
                                className="add_led_btn"
                            >
                                Add LED
                            </button>
                        </div>

                        <button
                            onClick={async (e) => {
                                add_widget_plus(e);
                                widget_add(e);
                            }}
                            className="btn_olustur_add_widget"
                        >
                            Create
                        </button>
                    </div>
                    <div id="k-w-t" className="link_widget">
                        {btn_widget_control === "" ? (
                            <>
                                <i onClick={close_widget_add3} className="fa fa-times"></i>
                                <div
                                    id="link"
                                    onClick={() => {
                                        Set_btn_widget_control("link");
                                    }}
                                    className="box"
                                >
                                    Link Widget
                                </div>
                                <div
                                    onClick={() => {
                                        Set_btn_widget_control("program");
                                    }}
                                    id="program"
                                    className="box"
                                >
                                    Program Widget
                                </div>
                            </>
                        ) : btn_widget_control === "link" ? (
                            <>
                                <div className="choose_page_part">
                                    Choose Page
                                    <select
                                        style={{ maxWidth: "180px" }}
                                        name="page_select"
                                        id="page_select_id"
                                    >
                                        {props.widgets_library_names.map((i, index) => {
                                            return (
                                                <option key={index} value={i}>
                                                    {i}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                <button
                                    onClick={(e) => {
                                        Set_btn_widget_control("");

                                        document.querySelectorAll("#k-w-t").forEach((i) => {
                                            i.style.opacity = "0";
                                            i.style.zIndex = "-1000000000";
                                        });
                                        const widgets = document.querySelector(".link_widget");
                                        widgets.classList.toggle("link_widget_active");
                                        const widgets2 = document.querySelector(
                                            ".select_widget_type"
                                        );
                                        widgets2.style.opacity = "1";
                                        var e_2 = document.querySelector("#page_select_id");
                                        link_widget.push({
                                            page_name: e_2.options[e_2.selectedIndex].text,
                                        });
                                        console.log(e_2.options[e_2.selectedIndex].text);
                                        widget_add(e);
                                    }}
                                    className="btn_olustur_add_widget"
                                >
                                    Create
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="choose_page_part">
                                    Choose Program
                                    <select
                                        style={{ maxWidth: "180px" }}
                                        name="page_select"
                                        id="page_select_id"
                                    >
                                        {props.widgets_library_names.map((i, index) => {
                                            return (
                                                <option key={index} value={i}>
                                                    {i}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                <button
                                    onClick={(e) => {
                                        Set_btn_widget_control("");
                                        document.querySelectorAll("#k-w-t").forEach((i) => {
                                            i.style.opacity = "0";
                                            i.style.zIndex = "-1000000000";
                                        });
                                        const widgets = document.querySelector(".link_widget");
                                        widgets.classList.toggle("link_widget_active");
                                        const widgets2 = document.querySelector(
                                            ".select_widget_type"
                                        );
                                        widgets2.style.opacity = "1";
                                        var e_2 = document.querySelector("#page_select_id");
                                        link_widget.push({
                                            page_name: e_2.options[e_2.selectedIndex].text,
                                        });
                                        console.log(e_2.options[e_2.selectedIndex].text);
                                        widget_add(e);
                                    }}
                                    className="btn_olustur_add_widget"
                                >
                                    Create
                                </button>
                            </>
                        )}
                    </div>
                    {
                        <div id="k-w-t" className="gauge_widget">
                            <i onClick={close_widget_add4} className="fa fa-times"></i>
                            <div className="gauge_part">
                                <div className="gauge_1">
                                    <GaugeChart
                                        id="gauge-chart"
                                        percent={Number(gaugeValue)}
                                        {...gaugeConfig}
                                    />
                                </div>
                                <div className="gauge_2">
                                    <div className="nokta">
                                        <h4>Tag</h4>
                                        <select
                                            style={{ maxWidth: "180px" }}
                                            name="gauge_select"
                                            id="gauge_select_id"
                                        >
                                            {props.tag_list.map((i, index) => {
                                                return (
                                                    <option key={index} value={i.tagId}>
                                                        {i.tagName}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                    <div className="max-Value">
                                        <h4>Max Value</h4>
                                        <input
                                            id="cm0-x7y"
                                            onChange={onChangeGaugeMax}
                                            value={gaugeValueMax}
                                            type="text"
                                            placeholder="max value"
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={(e) => {
                                    var e_2 = document.querySelector("#gauge_select_id");
                                    var e_3 = document.querySelector("#cm0-x7y").value;
                                    if (String(e_3) !== "") {
                                        gaugeWidget.push({
                                            tagId: e_2.options[e_2.selectedIndex].value,
                                            max_value: Number(e_3),
                                        });
                                        SetTags((prevArray) => [
                                            ...prevArray,
                                            { tagId: e_2.options[e_2.selectedIndex].value },
                                        ]);
                                        tags_.push(e_2.options[e_2.selectedIndex].value);
                                    }
                                    var newdata = render_items;

                                    var newobj = {
                                        id: newdata.length - 1,
                                        x: Math.floor(Math.random() * 300),
                                        y: Math.floor(Math.random() * 300),
                                        type: "gauge",
                                        elementDetails: {
                                            tagName: e_2.options[e_2.selectedIndex].textContent,
                                            max_value: Number(e_3),
                                            tagId: e_2.options[e_2.selectedIndex].value,
                                        },
                                    };
                                    Set_items3((prevArray) => [...prevArray, newobj]);
                                    widget_add(e);
                                }}
                                className="btn_olustur_add_widget"
                            >
                                Create
                            </button>
                        </div>
                    }
                    {/* <div id='k-w-t' className="trend_widget">
                        <i onClick={close_widget_add5} className="fa fa-times"></i>
                        <div className="trend_part">
                            <div className='trend_1'>
                                <Line data={chartData} options={chartOptions} />
                            </div>
                            <div className="trend_2">
                                <div className="nokta">
                                    <h4>Tag</h4>
                                    <select style={{ maxWidth: "180px" }} name="trend_select" id="trend_select_id">{props.tag_list.map((i, index) => {
                                        return <option key={index} value={i.tagId}>{i.tagName}</option>
                                    })}</select>
                                </div>

                                <div className="y-label_axis">
                                    <h4>X-Axis Name:</h4>
                                    <input id='cm0-x7y-2' type="text" className='y-axis' placeholder='y-axis' />
                                </div>

                            </div>
                        </div>
                        <button onClick={(e) => {
                            var e_2 = document.querySelector("#trend_select_id")
                            var toplam = 0;
                            var e_4 = document.querySelectorAll("#cm0-x7y-2");
                            var e_6 = document.querySelector(".y-axis")
                            for (let i of e_4) {
                                if (i.value === "") {
                                    toplam++
                                }
                            }
                            if (toplam < 1) {
                                trends_widget.push({ "tagId": e_2.options[e_2.selectedIndex].value, "y_axis": e_6.value })
                                SetTags((prevArray) => [...prevArray, { "tagId": e_2.options[e_2.selectedIndex].value }])
                                tags_.push(e_2.options[e_2.selectedIndex].value)

                            } else {
                                alert("Değerleri eksiksiz girin!")
                            }

                            widget_add(e)
                        }} className="btn_olustur_add_widget">
                            Create
                        </button>
                    </div> */}
                    <div id="k-w-t" className="input_select_widget">
                        <i onClick={close_widget_add6} className="fa fa-times"></i>
                        <input
                            style={{ color: "rgb(34,34,34)", fontSize: "21px" }}
                            type="text"
                            value={main_title2}
                            onChange={add_main_title2}
                            placeholder="Main Title (optional)"
                        />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive3 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick3}
                                onBlur={handleDropdownBlur3}
                            >
                                <div className="select">
                                    <span>{selectedOption3}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue3} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick3(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_3"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive1 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick1}
                                onBlur={handleDropdownBlur1}
                            >
                                <div className="select">
                                    <span>{selectedOption1}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue1} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick1(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_1"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive2 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick2}
                                onBlur={handleDropdownBlur2}
                            >
                                <div className="select">
                                    <span>{selectedOption2}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue2} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick2(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_2"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "80%",
                                marginBottom: "-12px",
                            }}
                        >
                            <div
                                style={{ width: "150px" }}
                                className={`dropdown ${isActive4 ? "active" : ""}`}
                                tabIndex="1"
                                onClick={handleDropdownClick4}
                                onBlur={handleDropdownBlur4}
                            >
                                <div className="select">
                                    <span>{selectedOption4}</span>
                                    <i className="fa fa-chevron-left"></i>
                                </div>
                                <input type="hidden" value={inputValue4} />
                                <ul style={{ width: "150px" }} className="dropdown-menu">
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"1"}
                                        name={"start"}
                                        key={"1"}
                                    >
                                        {"Start"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"2"}
                                        name={"BMS"}
                                        key={"2"}
                                    >
                                        {"BMS"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"3"}
                                        name={"normal"}
                                        key={"3"}
                                    >
                                        {"Normal"}
                                    </li>
                                    <li
                                        className="swerf"
                                        onClick={(e) => {
                                            handleOptionClick4(e.target.textContent);
                                        }}
                                        id={"4"}
                                        name={"stop"}
                                        key={"4"}
                                    >
                                        {"Stop"}
                                    </li>
                                </ul>
                            </div>
                            <select
                                style={{
                                    maxWidth: "180px",
                                    padding: "12px 8px",
                                    position: "relative",
                                    left: "12px",
                                }}
                                name="select_value"
                                id="select_value_id_4"
                            >
                                {props.tag_list.map((i) => {
                                    return <option value={i.tagId}>{i.tagName}</option>;
                                })}
                            </select>
                        </div>

                        <button
                            onClick={async (e) => {
                                add_widget_plus2(e);
                                widget_add(e);
                            }}
                            className="btn_olustur_add_widget"
                        >
                            Create
                        </button>
                    </div>
                    <div className="button2_select_widget" >
                        <div className=" select_part">
                            <div className="row">
                                <span>Button Name:</span>
                                <input id={temp_id} onChange={(e) => {
                                    var newdata = items3;
                                    newdata.forEach((item) => {
                                        if (
                                            String(item.id) === String(e.target.id)
                                        ) {
                                            item.elementDetails.text =
                                                e.target.value
                                        }
                                    });
                                    console.log(newdata);
                                    Set_items3(newdata);
                                }} type="text" className="btn2_name-input" />
                            </div>

                        </div>
                        <button id={items3.length} onClick={(e) => {
                            document.querySelector(".button2_select_widget").classList.toggle("button2_select_widget_active")
                            var newdata = items3;
                            newdata.forEach((item) => {
                                console.log(item);
                                if (
                                    String(item.id) === String(e.target.id)
                                ) {
                                    item.elementDetails.text = e.target.parentElement.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.value

                                }
                            });
                            console.log(newdata);
                            Set_items3(newdata);
                            Set_temp_id("")


                            history.push("/create_pop_up");

                        }}
                        >Create</button>
                    </div>
                    {/* <div id="k-w-t" className='manuel_widget'>
                    <i onClick={close_widget_add7} className="fa fa-times"></i>
                    <div className="row">
                        <input type="text" className="input1" />
                        <input type="text" className="input2" />
                    </div>
                    <div className="row">
                        <input type="text" className="input1" />
                        <input type="text" className="input2" />
                    </div>
                    <div className="row"></div>
                    <div className="row"></div>
                    <div className="row"></div>

                    <button onClick={async (e) => {
                        add_widget_plus2(e)
                        widget_add(e)
                    }
                    } className="btn_olustur_add_widget">
                        Create
                    </button>
                </div> */}

                    <div className="vrf_detail_popup">
                        <div>
                            {pop_up_widget.map((item, index) => {
                                console.log(item);
                                if ((String(item.id)) === String(pop_up_id)) {
                                    return (
                                        <div className="card-body_white_paper white_space">
                                            <i onClick={close_vrf_pop_up} style={{ cursor: "pointer", backgroundColor: "white", borderRadius: "26px", width: "26px", height: "26px", padding: "4px", display: "flex", alignItems: "center", marginBottom: "8px", justifyContent: "center", position: "relative", cursor: "pointer", left: "93%", top: "-260px", color: "red", fontWeight: "600", fontSize: "22px", cursor: "pointer" }} className="fa fa-times"></i>
                                            <div id={item.id} className="white_paper_xs_3_big">

                                                <div>
                                                    {item.elementDetails.map((item, index) => {
                                                        console.log(item);
                                                        if (item.type === "text") {
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div id={item.id}>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: "white",
                                                                                width: "40%",
                                                                            }}
                                                                            type="text"
                                                                            className="drag-input-text"
                                                                            value={item.elementDetails.text}
                                                                        />
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "title") {
                                                            console.log(item);
                                                            return (
                                                                <Draggable
                                                                    disabled={true}
                                                                    position={{ x: item.x, y: item.y }}
                                                                >
                                                                    <div id={item.id}>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: "white",
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let data_new = items3;
                                                                                data_new.forEach((i) => {
                                                                                    if (
                                                                                        String(i.id) ===
                                                                                        e.target.parentElement.id
                                                                                    ) {
                                                                                        i.elementDetails.text =
                                                                                            e.target.value;
                                                                                    }
                                                                                });
                                                                                Set_items3(data_new);
                                                                            }}
                                                                            type="text"
                                                                            value={
                                                                                item.elementDetails.text !==
                                                                                    ""
                                                                                    ? item.elementDetails.text
                                                                                    : undefined
                                                                            }
                                                                            className="drag-input-title"
                                                                        />
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "label") {
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div
                                                                        id={item.id}
                                                                        className="main_label"
                                                                    >
                                                                        {item.main_title !== "" ? (
                                                                            <h5
                                                                                style={{
                                                                                    display: "block",
                                                                                    height: "20px",
                                                                                    margin: "0",
                                                                                }}
                                                                                className="main_titile_label_widget"
                                                                            >
                                                                                {item.main_title}
                                                                            </h5>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        <span>
                                                                            {item.text}{" "}
                                                                            {item.led === "true" ? (
                                                                                <input
                                                                                    className="led_checkbox"
                                                                                    type="checkbox"
                                                                                />
                                                                            ) : (
                                                                                <input
                                                                                    className="led_checkbox"
                                                                                    type="checkbox"
                                                                                    style={{
                                                                                        backgroundColor: "red",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                        <div
                                                                            style={{ height: "auto" }}
                                                                            className="proggress_bar_default"
                                                                        >
                                                                            <div
                                                                                title={`Değer: 100`}
                                                                                style={{
                                                                                    textAlign: "center",
                                                                                    color: "white",
                                                                                    padding: "8px 0",
                                                                                    fontWeight: "600",
                                                                                    height: "100%",
                                                                                    fontSize: "11px",
                                                                                    backgroundColor: "red",
                                                                                    width: `60%`,
                                                                                    borderRadius: "8px",
                                                                                }}
                                                                            >
                                                                                100
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "led") {
                                                            let color = "green";
                                                            if (item.elementDetails.color) {
                                                                color = item.elementDetails.color;
                                                            }
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div id={item.id}>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: color,
                                                                            }}
                                                                            type="checkbox"
                                                                            id="white_space_led"
                                                                        />
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "gauge") {
                                                            var percent = Number(

                                                                Number(props.tag_values.filter((x) => String(x.tagId) === String(item.elementDetails.tagId)).map((x) =>
                                                                    Number(x.tagValue.replaceAll(",", ".")).toFixed(2))) / Number(item.elementDetails.max_value)
                                                            );
                                                            var değer = props.tag_values
                                                                .filter(
                                                                    (x) =>
                                                                        String(x.tagId) ===
                                                                        String(item.elementDetails.tagId)
                                                                )
                                                                .map((x) =>
                                                                    Number(
                                                                        x.tagValue.replaceAll(",", ".")
                                                                    ).toFixed(2)
                                                                );
                                                            console.log(percent, değer);
                                                            return (
                                                                <div>
                                                                    <Draggable
                                                                        disabled={true}
                                                                        position={{
                                                                            x: item.x,
                                                                            y: item.y,
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="gauge_widget_tool"
                                                                            id={item.id}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    maxWidth: "100px",
                                                                                    backgroundColor:
                                                                                        "rgb(240,240,240)",
                                                                                    border:
                                                                                        "2px solid rgb(40,40,40)",
                                                                                    padding: "4px 0px",
                                                                                }}
                                                                                className="gauge_widget_tool"
                                                                                id={item.id}
                                                                            >
                                                                                <GaugeChart
                                                                                    style={{
                                                                                        maxWidth: "100px",
                                                                                    }}
                                                                                    arcColor={getGaugeColor(
                                                                                        percent
                                                                                    )}
                                                                                    id="gauge-chart"
                                                                                    percent={percent}
                                                                                    {...gaugeConfig}
                                                                                />
                                                                                <div className="gauge_values_display_page_toolbox">
                                                                                    <span>0</span>
                                                                                    <span>{değer}</span>
                                                                                    <span>
                                                                                        {
                                                                                            item.elementDetails
                                                                                                .max_value
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                                <span className="w_gauge_name_tag">{item.elementDetails.tagName}</span>
                                                                            </div>
                                                                        </div>
                                                                    </Draggable>
                                                                </div>
                                                            );
                                                        }
                                                        if (item.type === "button") {
                                                            return (
                                                                <Draggable
                                                                    disabled={true}
                                                                    position={{ x: item.x, y: item.y }}
                                                                >
                                                                    <select
                                                                        id={item.id}
                                                                        name="button_link_select"
                                                                        className="button_link_select"
                                                                    >
                                                                        {props.widgets_library.map((item) => {
                                                                            return (
                                                                                <option value={index}>
                                                                                    {item.pageName}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "select") {
                                                            return (
                                                                <Draggable
                                                                    position={{ x: item.x, y: item.y }}
                                                                    disabled={true}
                                                                >
                                                                    <div id={item.id}>
                                                                        <select
                                                                            name="tag_select"
                                                                            id="tag_select"
                                                                        >
                                                                            <option
                                                                                key={"1"}
                                                                                value={item.elementDetails.id}
                                                                            >
                                                                                {item.elementDetails.text}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "text_box") {
                                                            return (
                                                                <Draggable
                                                                    disabled={true}
                                                                    position={{ x: item.x, y: item.y }}
                                                                >
                                                                    <span
                                                                        id={item.id}
                                                                        className="w_text_box_span"
                                                                    >
                                                                        <input
                                                                            value={item.elementDetails.text}
                                                                            disabled={true}
                                                                            className="w_text_box_inp"
                                                                        />
                                                                    </span>
                                                                </Draggable>
                                                            );
                                                        }
                                                        if (item.type === "tag") {
                                                            var değer = props.tag_values.filter(x => String(x.tagId) === String(item.elementDetails.tagId)).map(x => Number(x.tagValue.replaceAll(",", ".")).toFixed(2))

                                                            return <Draggable disabled={true} position={{ x: item.x, y: item.y }}>
                                                                <div className={`tag_${item.id}`} id={item.id}>
                                                                    <div className="tag_ws3">
                                                                        <p style={{ marginRight: "12px" }}>{item.elementDetails.text}</p>
                                                                        <p className='p_tag_value_TAG'>{değer}</p>

                                                                    </div>
                                                                </div>

                                                            </Draggable>
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                            })}

                        </div>
                    </div>

                    <div className="tag_pop_up">
                        <i onClick={() => {
                            document.querySelector(".tag_pop_up").classList.toggle("tag_pop_up_active")
                        }} style={{ position: "relative", left: "43%", color: "brown", fontWeight: "600", fontSize: "18px", cursor: "pointer" }} className="fa fa-times"></i>

                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "4%",
                            marginBottom: "3%"
                        }}>
                            <p>Choose Tag</p>
                            <select style={{ maxWidth: "250px" }} name="tag_select_select" id="tag_select_select_id">{props.tag_list.map((i, index) => {
                                return <option key={index} value={i.tagId}>{i.tagName}{" " + i.tagId}</option>
                            })}</select
                            >
                        </div>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            marginTop: "4%",
                            marginBottom: "3%"
                        }}>
                            <p>Label:</p>
                            <input type="text" placeholder='label' className='tag_label_inp' />
                        </div>

                        <button id={render_items.length - 1} onClick={(e) => {



                            var newdata = items3;
                            newdata.forEach((item) => {
                                if (
                                    String(item.id) === String(e.target.id)
                                ) {
                                    item.elementDetails.tagId =
                                        e.target.parentElement.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.options[
                                            e.target.parentElement.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.selectedIndex
                                        ].value;
                                    item.elementDetails.text = e.target.parentElement.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling.value

                                }
                            });

                            var değer = props.tag_values.filter(x => String(x.tagId) === String(e.target.parentElement.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.options[
                                e.target.parentElement.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.selectedIndex
                            ].value)).map(x => Number(x.tagValue.replaceAll(",", ".")).toFixed(2))

                            console.log(document.querySelector(`.tag_${e.target.id}`));

                            document.querySelector(`.tag_${e.target.id}`).firstElementChild.firstElementChild.nextElementSibling.innerHTML = değer[0]
                            document.querySelector(`.tag_${e.target.id}`).firstElementChild.firstElementChild.innerHTML = e.target.parentElement.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling.value

                            console.log(newdata);
                            Set_items3(newdata);
                        }}>Create</button>


                    </div>

                    <div className="notifications-kapsiyici">
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: "auto",
                                maxHeight: "80%",
                                maxWidth: "60%",
                                overflow: "hidden",
                                marginTop: "10%",
                            }}
                        >
                            <div className="redirect_to_dashboard-btn">

                                <div style={{ pointerEvents: page_management_yazma ? "all" : "none", opacity: page_management_yazma ? "1" : "0.85", width: "18%" }}
                                    onClick={() => {
                                        history.push("/addWidgetToLibrary")
                                    }}>Yeni Widget <i className="fa fa-plus"></i></div>
                            </div>
                            <div className="pages_man">
                                <div className="row_inital">
                                    <div className="kd">
                                        <div className="second">Template İsmi</div>
                                    </div>
                                    <div style={{ marginRight: "-12%" }} className="third">Edit</div>
                                </div>
                                {props.widgets_library.length > 0 ? (
                                    props.widgets_library.sort((a, b) => {
                                        const nameA = typeof a.widget_name === "string" ? a.widget_name : "";
                                        const nameB = typeof b.widget_name === "string" ? b.widget_name.toLowerCase() : "";
                                        return nameA.localeCompare(nameB);
                                    }).map((i, index) => {
                                        console.log(i);
                                        return (
                                            <div id={i.widgetId} className="rowX">
                                                <div className="kd">
                                                    <div style={{ marginLeft: "0" }} className="second">{i.widget_name}</div>
                                                </div>
                                                <div className="third">
                                                    <button
                                                        disabled={!page_management_yazma}
                                                        style={{ pointerEvents: page_management_yazma ? "all" : "none" }}
                                                        onClick={(e) => {
                                                            var text =
                                                                e.target.parentElement.parentElement
                                                                    .firstElementChild.firstElementChild
                                                                    .textContent;
                                                            console.log(text);

                                                            edit_btn_func(e, text);
                                                        }}
                                                    >
                                                        Edit
                                                    </button>

                                                    <button
                                                        disabled={!page_management_silme}
                                                        style={{ pointerEvents: page_management_silme ? "all" : "none" }}
                                                        onClick={(e) => {
                                                            delete_page(e);
                                                        }}
                                                    >
                                                        Sil
                                                    </button>

                                                </div>
                                            </div>
                                        );


                                    })
                                ) : (
                                    <div
                                        style={{
                                            height: "100vh",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            marginTop: "30%",
                                        }}
                                        className="loading"
                                    >
                                        <img style={{ width: "15%" }} src={loading_} alt="" />

                                        <p
                                            style={{
                                                marginTop: "10%",
                                                fontSize: "21px",
                                                color: "rgb(80,80,80)",
                                                width: "100%",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                fontFamily:
                                                    "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                                            }}
                                        >
                                            Sayfalar yükleniyor. Lütfen Bekleyiniz...
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
            )}
        </>
    );
};

const MapStateToProps = (state) => {
    return {
        pages: state.project_reducer.pages,
        pages_names: state.project_reducer.pages_names,
        auth_reducer: state.auth_reducer.user_id,
        profile: state.project_reducer.profile_infos,
        company_id: state.project_reducer.company_id,
        secret_key: state.project_reducer.secret_key_db_firebase,
        tag_list: state.project_reducer.tag_list,
        current_path: state.project_reducer.current_path,
        toolbox: state.project_reducer.toolbox_items,
        white_space_: state.project_reducer.white_space_items,
        white_space_3: state.project_reducer.pop_up_widget,
        sistem_izleme_control: state.project_reducer.sistem_izleme_control,
        profile_infos: state.project_reducer.profile_infos,
        yetkilendirme_state: state.project_reducer.yetkilendirme_state,
        group_id: state.project_reducer.group_id,
        users_list: state.project_reducer.users_list,
        com_id: state.project_reducer.company_id,
        render_items_length: state.project_reducer.render_toolbox_items,
        _tag_ids: state.project_reducer.tag_ids,
        tag_values: state.project_reducer.tag_values,
        temp_id: state.project_reducer.temp_id,
        widgets_library: state.project_reducer.widget_library,
        temp_com_id: state.project_reducer.temp_com_id



    };
};

export default connect(MapStateToProps)(Template_Widget_Management);
